import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { ResourceListSelectors, RoomTypeState } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): RoomTypeState => state.roomType,
);

export default selectors;
